var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var TabPane = /* @__PURE__ */ __name(function TabPane2(_ref) {
  var children = _ref.children;
  return children;
}, "TabPane");
export {
  TabPane
};
